export const cards = [
  {
    id: 1,
    key: "terminal_1",
    images: [
      "/assets/images/terminals/1.png",
    ],
  },
  {
    id: 2,
    key: "terminal_2",
    images: [
      "/assets/images/terminals/3.png",
    ],
  },
];

